// Create a new file LoadingIndicator.js
const LoadingIndicator = () => {
    return (
      <div className="flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-blue-500"></div>
      </div>
    );
  };
  
  export default LoadingIndicator;